module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VAXoSE/images/9781488091452.jpg?1705359744467",
      "alt": "This image is the cover for the book Yuletide Homecoming, A Snowglobe Christmas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Yuletide Homecoming, A Snowglobe Christmas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author’s heartwarming holiday romance, a soldier’s return to Montana rekindles a love that’s meant to last.")]), _c('br'), _c('br'), _vm._v("Five years ago, Rafe Westfield broke his fiancée’s heart when he left to join the military. Now the battle-scarred soldier is back in Snowglobe, Montana, and Amy Caldwell knows a broken heart isn’t what she wants for Christmas. But trying to keep her distance is nearly impossible, thanks to the spirit of the season, a well-meaning family, and a sweet stray dog who keeps bringing her and Rafe together. Maybe this time forever . . . "), _c('br'), _c('br'), _c('i', [_vm._v("Yuletide Homecoming")]), _vm._v(" was originally published in 2012 as part of the 2-in-1 anthology, "), _c('i', [_vm._v("A Snowglobe Christmas")]), _vm._v(".\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Linda Goodnight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("New York Times and USA Today Bestseller, Linda Goodnight is the winner of the RITA and other highly acclaimed awards for her emotional fiction. Active in orphan ministry, this former nurse and teacher enjoys writing fiction that carries a message of hope and light in a sometimes dark world. A country girl, she lives in Oklahoma. Readers may contact her through her website: "), _c('a', {
    attrs: {
      "href": "http://www.lindagoodnight.com"
    }
  }, [_vm._v("www.lindagoodnight.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0